(function () {
    'use strict';

    var scrollingService = function ($document) {

        var currentScrollingTarget;

        function scrollTo(elementToScrollTo, offset, scrollDuration, easing) {
            // Prevent scroll to specified position if it's already happening.
            if (elementToScrollTo === currentScrollingTarget) {
                return;
            }
            else {
                currentScrollingTarget = elementToScrollTo;
            }

            var target = angular.element($document[0].getElementById(currentScrollingTarget));
            if (target.length) {
                $document.scrollToElementAnimated(target, offset, scrollDuration, easing);
                // Reset current scrolling target so that we can scroll there consecutively if requested.
                currentScrollingTarget = null;
            }
        }

        return {
            scrollTo: scrollTo
        };
    };

    scrollingService.$inject = ['$document'];
    angular.module('ecap.common').factory('scrollingService', scrollingService);
})();